module.exports = __webpack_public_path__ + "img/map-outfield.7162e836.png";